module.exports = Joi =>
  Joi.string()
    .pattern(/^[a-z\d\-_\s]+$/i)
    .min(2)
    .max(255)
